import React, { useMemo } from 'react'
import type { SelectProps } from '@ztechapps/webui.input'
import { TemplateSelect } from '@ztechapps/webui.data-tools'
import { chatTemplateCategory } from '@ztechapps/chat.common'
const placeholder = 'Insert a template…'
export type ChatTemplateSelectProps = SelectProps & { templateCategory?: string | string[] }
export const ChatTemplateSelect = (props: ChatTemplateSelectProps) => {
  const { templateCategory } = props
  const newTemplateCategory = useMemo(() => templateCategory ?? chatTemplateCategory, [templateCategory])

  return <TemplateSelect templateCategory={newTemplateCategory} placeholder={placeholder} {...props} />
}
